













import Vue from 'vue'
import { InstantSwitchElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'InstantSwitchEl',
  props: {
    templateItemData: {
      type: Object as () => InstantSwitchElInterface,
      required: true
    }
  },
  data: () => ({
    selected: false,
    processing: false
  }),
  mounted () {
    this.selected = this.templateItemData.value
  },
  methods: {
    switchAction () {
      this.processing = true

      this.$axios.post(decodeURIComponent(this.templateItemData.uri), new URLSearchParams({ status: this.selected.toString() }))
        .then(() => {
          this.processing = false
        })
        .catch(() => {
          this.selected = !this.selected
          this.processing = false
        })
    }
  }
})
